import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../../components/Button';
import Icon from '../../components/Icon';
import Message from '../../components/Message';
import { REP_VISITS_SUBSCRIPTION } from '../Authorization/constants';
import SubscriptionInActive from '../../components/SubscriptionInactive';
import messages from './messages';
import './styles.css';

export const LoadingHint = () => (
  <Message styleName="warning-text">
    <FormattedMessage {...messages.exportEventsDownloading} />
  </Message>
);

export const DownloadHint = () => (
  <Message styleName="warning-text">
    <FormattedMessage {...messages.exportEventsDownloadReady} />
  </Message>
);

export const DownloadIE = () => (
  <Message info icon styleName="empty">
    <Icon styleName="warning-icon" name="exclamation" />
    <FormattedMessage {...messages.exportEventsDownloadIE} />
  </Message>
);

export const Loading = () => (
  <Icon name="spinner" loading />
);

export const Error = () => (
  <Message warning styleName="empty" data-cy="repvisits-calendar-export-error-message">
    <FormattedMessage styleName="warning-text" {...messages.exportEventsErrorContent} />
  </Message>
);

export const Empty = () => (
  <Message warning styleName="empty" data-cy="repvisits-calendar-export-warning-message">
    <FormattedMessage styleName="warning-text" {...messages.exportEventsEmptyContent} />
  </Message>
);

export const InvalidSubscription = () => (
  <SubscriptionInActive allOf={REP_VISITS_SUBSCRIPTION}>
    <Button basic title="Export" styleName="export noPrint" color="teal" disabled>
      <FormattedMessage {...messages.exportEvents} />
    </Button>
  </SubscriptionInActive>
);
